module.exports = __webpack_public_path__ + "img/TKK.4bef1fff.svg";